import { gql, useMutation } from '@apollo/client';
import { createRoute, RoutesEnum } from 'common/routes';
import { useSessionContext } from 'common/session/session-context';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { FiHeart } from 'react-icons/fi';
import { Button } from 'reactstrap';

type Props = {
	specialistId: number;
};

const INSERT_FAVORITE_SPECIALISTS_ONE_MUTATION = gql`
	mutation insert_favorite_specialists_one($specialist_id: Int!) {
		insert_favorite_specialists_one(object: { specialist_id: $specialist_id }) {
			specialist_id
			user_id
			id
		}
	}
`;

const DELETE_FAVOURITE_SPECIALISTS_ONE_MUTATION = gql`
	mutation delete_favorite_specialists_one(
		$user_id: Int!
		$specialist_id: Int!
	) {
		delete_favorite_specialists(
			where: {
				user_id: { _eq: $user_id }
				specialist_id: { _eq: $specialist_id }
			}
		) {
			affected_rows
		}
	}
`;

export const AddToFavoriteButton: React.FC<Props> = ({ specialistId }) => {
	const [
		addToFavorite,
		{ data: dataAdd, loading: loadingAdd, error: errorAdd }
	] = useMutation(INSERT_FAVORITE_SPECIALISTS_ONE_MUTATION);
	const [
		deleteFromFavorite,
		{ data: dataDelete, loading: loadingDelete, error: errorDelete }
	] = useMutation(DELETE_FAVOURITE_SPECIALISTS_ONE_MUTATION);

	const userSession = useSessionContext();

	const router = useRouter();

	if (!userSession) {
		return null;
	}

	const [isFavorite, setIsFavorite] = useState(
		Boolean(
			userSession.session?.favorite_specialists.find(
				(item) => item.specialist_id === specialistId
			)
		)
	);

	const onClick = async (event: React.MouseEvent) => {
		event.preventDefault();

		if (!userSession || !userSession.session) {
			router.push(createRoute(RoutesEnum.Customer_SignUp));

			return;
		}

		if (isFavorite) {
			await deleteFromFavorite({
				variables: {
					specialist_id: specialistId,
					user_id: userSession.session.id
				}
			});

			setIsFavorite(false);
		} else {
			await addToFavorite({
				variables: {
					specialist_id: specialistId
				}
			});

			setIsFavorite(true);
		}
	};

	if (userSession.session && userSession.session.role === 'place') {
		return null;
	}

	return (
		<>
			{isFavorite && (
				<a
					onClick={onClick}
					className={`
          cursor-pointer
                     inline-flex gap-2 border border-blue-600 text-blue-600 font-bold px-4 py-3 md:py-2 rounded-lg
                     items-center bg-blue-50 text-xs md:text-base`}
				>
					<FiHeart />
					<span>Zapisano</span>
				</a>
			)}
			{!isFavorite && (
				<Button
					color='secondary'
					onClick={onClick}
					outline
					className='cursor-pointer inline-flex gap-2 border items-center'
				>
					<FiHeart />
					<span className='text-xs md:text-base'>Zapisz</span>
				</Button>
			)}
		</>
	);
};
